import permissions from "app/permissions";
import { ACADEMIC_REQUEST_DATA_ISSUES, StudentServicePath } from "utils/constants";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import ListAcademicRequestDataIssues from "./List";
import ShowAcademicRequestDataIssue from "./Show/Show";

export const resources = {
  isMenu: true,
  icon: <ReportProblemIcon />,
  name: StudentServicePath + ACADEMIC_REQUEST_DATA_ISSUES,
  title: "Проблем с прехвърлените данни",
  list: <ListAcademicRequestDataIssues />,
  show: <ShowAcademicRequestDataIssue />,
  permission: permissions.canPreviewAcademicRequestDataIssues,
  showPermission: permissions.canPreviewAcademicRequestDataIssues,
};
